function update_limit() {
    const repeaterWrap = document.querySelector('.repeater-field-warp-item-data');
    const LIMIT = 20;

    if (!repeaterWrap) return;

    // set data-limit attribute
    repeaterWrap.setAttribute('data-limit', LIMIT);

    const checkLimit = () => {
        // select the Add button fresh each time
        const addButton = document.querySelector('a.gf-repeater-field-button-add');
        if (!addButton) return;

        // count only actual repeater items
        const itemsCount = repeaterWrap.querySelectorAll('.repeater-field-item').length;

        if (itemsCount >= LIMIT) {
            addButton.classList.add('hidden');
            console.log('Add button hidden');
        } else {
            addButton.classList.remove('hidden');
            console.log('Add button visible');
        }
    };

    setTimeout(checkLimit, 100);

    const observer = new MutationObserver(() => {
        setTimeout(checkLimit, 50); 
    });
    observer.observe(repeaterWrap, { childList: true, subtree: true });

    document.addEventListener('click', (e) => {
        if (e.target && e.target.matches('a.gf-repeater-field-button-add')) {
            setTimeout(checkLimit, 50);
        }
    });
}

function init() {
    update_limit();
}


setTimeout(init, 200);
